import { PROFILE_STATUS, useVerifyProfile } from '@/providers/VerifyProfileProvider';
import { Box } from '@mantine/core';
import { ProfileCompleteForm } from './ProfileCompleteForm';
import { ProfileCongratsInfo } from './ProfileCongratsInfo';
import { ProfileEmailSuccess } from './ProfileEmailSuccess';
import { ProfileIdVerification } from './ProfileIDVerification';
import { ProfileIdVerificationTablet } from './ProfileIDVerificationTablet';
import { ProfileRegistration } from './ProfileRegistration';
import { ProfileVerifyEmail } from './ProfileVerifyEmail';
export const ProfileRightSection: React.FC = () => {
  const {
    status,
    successes
  } = useVerifyProfile();
  return <Box h="100%" style={{
    zIndex: 1
  }}>
      {status === PROFILE_STATUS.REGISTRATION ? <ProfileRegistration visible="sm" /> : status === PROFILE_STATUS.VERIFY && !successes.has(PROFILE_STATUS.VERIFY) ? <ProfileVerifyEmail /> : status === PROFILE_STATUS.VERIFY && successes.has(PROFILE_STATUS.VERIFY) ? <ProfileEmailSuccess /> : status === PROFILE_STATUS.COMPLETE ? <ProfileCompleteForm /> : status === PROFILE_STATUS.VERIFICATION && !successes.has(PROFILE_STATUS.VERIFICATION) ? <>
          <ProfileIdVerification />
          <ProfileIdVerificationTablet />
        </> : status === PROFILE_STATUS.VERIFICATION && successes.has(PROFILE_STATUS.VERIFICATION) ? <ProfileCongratsInfo /> : null}
    </Box>;
};